var _defs, _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2933.3 1274.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n        font-family: Radikal-Bold, Radikal;\n        font-size: 413.1px;\n        font-weight: 700;\n        letter-spacing: 0em;\n      }\n\n      .st1 {\n        fill: #0bb2a2;\n      }\n\n      .st1, .st2, .st3, .st4, .st5 {\n        isolation: isolate;\n      }\n\n      .st1, .st3, .st4, .st5 {\n        mix-blend-mode: multiply;\n      }\n\n      .st3 {\n        fill: #fc3896;\n      }\n\n      .st4 {\n        fill: #28c3f9;\n      }\n\n      .st5 {\n        fill: #fc9706;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_11",
    "data-name": "Calque_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1193.3,216.1c-211.8-166.6-896.4,171.6-896.4,171.6-96.3,87.5-13.6,407.2,60.5,545.1,26.6,49.4,128.4,71.1,256.4,76.3-4.4,47.1-12.3,134.6-12.3,156.4s77-79.1,114.4-155.5c210.8-3.8,453.4-39.5,553-67.2,181.6-50.5,136.2-560.3-75.6-726.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M2719.1,373.6S2041,22.7,1826.1,185.3c-214.9,162.6-269.8,671.4-89.2,725.3,66.3,19.8,196.6,44.3,338.8,60.7-4.4,48.1-10,112.9-10,131.3s57.1-52.6,96.9-122.5c220.1,19.1,443.2,13.4,485.9-62.6,76.7-136.5,165.4-454.7,70.7-543.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1830.6,352.4c-211.8-166.6-896.4,171.6-896.4,171.6-96.3,87.5-13.6,407.2,60.5,545.1,49.1,91.3,355.3,88,608.5,60.7,30.5,72.5,75,148.2,77.7,127.3,2.5-19,5.4-88.8,7.2-137.6,92.3-12.4,171.2-27.3,218.2-40.3,181.6-50.5,136.2-560.3-75.6-726.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1727.9,255.6S1049.8-95.3,834.9,67.3s-269.8,671.4-89.2,725.3c90.4,27,299.6,62.8,495.6,74.7,30.3,76.1,80.3,162.8,83.1,140.6,2.4-18.9,5.3-88.2,7.1-136.9,158.8,3.1,293.6-14.2,325.8-71.5,76.7-136.5,165.4-454.7,70.7-543.9h0Z"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st0",
    transform: "translate(588.1 585.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Contactez"), /*#__PURE__*/React.createElement("tspan", {
    x: 498.2,
    y: 323
  }, "nous"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.a6dd21e58f91e5929ec8b2fcc25b443a.svg";
export { ForwardRef as ReactComponent };